<template>
  <b-modal
    ref="scoutConfirmModal"
    id="scoutConfirmModal"
    modal-class="scout-confirm-modal"
    size="md"
    backdrop="static"
    centered
    hide-header
  >
  <div class="confirmation-content d-flex flex-column align-items-center">
    <p class="text-center" style="font-weight: bold; font-size: 16px;">スカウトを希望しますか？</p>
    <p class="text-center" style="font-weight: bold; font-size: 16px">スカウト希望は<span style="color: #ff0000;">1社につき1求人・合計10社</span>まで可能です</p>
    <p class="mt-4 font-12">
      あなたがこの求人でスカウトを希望していることが企業に通知されます（企業からのスカウトを確約するものではありません）<br />
      スカウト希望後の取り下げはできません
    </p>
    <p class="mt-2">

    </p>
  </div>
    <template #modal-footer>
      <div class="d-flex  w-100 align-items-center button-flex flex-row">
        <b-button 
          class="next-button" 
          @click="$emit('cancel')"
          :disabled="loading"
        >キャンセル</b-button
        >
        <b-button 
          class="scout-button" 
          @click="$emit('confirm')"
          :disabled="loading"
        >
          <span v-if="loading">送信中...</span>
          <span v-else>スカウト希望する</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ScoutConfirmationModal",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    show() {
      this.$refs.scoutConfirmModal.show();
    },
    hide() {
      this.$refs.scoutConfirmModal.hide();
    },
  },
};
</script>

<style scoped>
.button-flex {
  justify-content: space-around;
}

.font-12 {
  font-size: 12px;
}

.scout-confirm-modal .modal-footer {
  background: #ffffff !important;
  border-top: none !important;
  justify-content: center !important;
}

.scout-confirm-modal .confirmation-content {
  padding: 50px 10px;
}

.text-center {
  text-align: center;
}

.scout-button:disabled,
.next-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Mobile responsive styles for button container */
@media (max-width: 768px) {
  .d-flex.w-100 {
    gap: 10px;
  }

  .button-flex {
    justify-content: center !important;
    align-items: center !important;
  }
  
  .scout-button,
  .next-button {
    width: 318px !important;
    height: 53px;
  }
}
</style>
